var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      on: {
        drop: function ($event) {
          $event.preventDefault()
          return _vm.addFile.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _vm.classification
        ? _c(
            "span",
            {
              staticClass: "classification-footer",
              style: _vm.classificationStyle,
              attrs: { height: "1.5em" },
            },
            [_vm._v(_vm._s(_vm.classification))]
          )
        : _vm._e(),
      _vm.showTopbar
        ? _c("Topbar", {
            style: {
              "z-index": _vm.topbarZIndex,
              "margin-top": _vm.classification ? "1.5em" : "0",
            },
            attrs: {
              title: _vm.title,
              "minimal-topbar": _vm.minimalTopbar,
              "show-back-button": _vm.showBackButton,
            },
            on: {
              "toggle-drawer": function ($event) {
                _vm.drawer = !_vm.drawer
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _vm.showSearch ? _c("SearchBar") : _vm._e(),
                      _vm._t("topbar-content"),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _c("Sidebar", {
        on: {
          "changed-files": function ($event) {
            return _vm.$emit("changed-files")
          },
        },
        model: {
          value: _vm.drawer,
          callback: function ($$v) {
            _vm.drawer = $$v
          },
          expression: "drawer",
        },
      }),
      _c("v-main", [_c("UpdateNotification"), _vm._t("main-content")], 2),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }